<template>
  <div style="width: 100%; height: 100%">
    <div id="chartPieBox" style="width: 100%; height: 100%"></div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  name: "DataCount",
  props: {
    ratioList: Array,
  },
  data: () => ({
    msg: "Welcome to Your Vue.js App",
    list: [],
  }),

  mounted() {
    this.chartPie = echarts.init(document.getElementById("chartPieBox"));
    console.log(this.ratioList);
    // var list={};
    // for (var i = 0; i < this.ratioList.length; i++) {
    //   list.value = this.ratioList[i][3];
    //   list.name = this.ratioList[i][1];
    // }
    // console.log(list);
    var dates = this.ratioList.map(function (item) {
      return item[0];
    });
    this.list = this.ratioList.map(function (item) {
      return { value: item[2], name: item[0] };
    });
    // 指定图表的配置项和数据
    var option = {
      title: {
        y: "13px",
        text: "资金分布",
        left: "13",
        textStyle: {
          color: "#333333", // 主标题文字的颜色。
          fontStyle: "normal", // 主标题文字字体的风格。 'normal'  'italic'  'oblique'
          fontWeight: "normal", // 主标题文字字体的粗细。 'normal' 'bold'  'bolder'  'lighter' 500|600
          fontFamily: "sans-serif", // 主标题文字的字体系列。
          fontSize: 16, // 字体大小
          lineHeight: "30", // 行高
          // width ... , // 文字块的宽度
          // height ... , // 文字块的高度
          textBorderColor: "transparent", // 文字本身的描边颜色。
          textBorderWidth: 0, // 文字本身的描边宽度。
          textShadowColor: "transparent", // 文字本身的阴影颜色。
          // textShadowBlur: 0, // 文字本身的阴影长度。
          // textShadowOffsetX: 0, // 文字本身的阴影 X 偏移。
          // textShadowOffsetY: 0, //  文字本身的阴影 Y 偏移。
        },
      },
      //   tooltip: {
      //     trigger: "item",
      //     formatter: "{a} <br/>{b} : {c} ({d}%)",
      //   },
      legend: {
        // orient: 'vertical',
        // top: 'middle',
        icon: "plain",
        bottom: 15,
        itemWidth: 10,
        padding: 15,
        itemGap: 25, // 图形宽度。
        itemHeight: 10,
        left: "center",
        data: dates,
      },
      color: [
        "#3AA0FF",
        "#975FE4",
        "#435188",
        "#FBD337",
        "#4ECB73",
        "#4ECBCA",
        "#FB8C37",
        "#C08458",
        "#A1A1A1",
      ],
      series: [
        {
          name: "资金分布",
          type: "pie",
          radius: "55%",
          center: ["50%", "40%"],
          data: this.list,

          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
            normal: {
              label: {
                show: true,
                formatter: "{d}%",
              },
              labelLine: { show: true },
            },
          },
        },
      ],
    };

    // 使用刚指定的配置项和数据显示图表。
    this.chartPie.setOption(option);
  },
};
</script>